import { TableDataApiParams } from '@services/practices.service';
import { DataSourceBaseNew } from '@components/new-table/data-source-base-new.dataSource';
import { TablePracticeModel } from '@/models/tables/table-practices.model';
import { ApiService } from '@services/api.service';

export class DataSourceTable extends DataSourceBaseNew<TablePracticeModel> {
  constructor(private apiService: ApiService) {
    super();
  }

  loadData(params?: TableDataApiParams): void {
    this._isLoading$.next(true);

    this.apiService.getDataForTable(params).subscribe((data) => {
      this.elements$.next(data.content);
      this._totalElements$.next(data.totalElements);
      this._isLoading$.next(false);
    });
  }
}
